export default __webpack_public_path__ + "static/media/large.f7341130.jpg";